
var openAudionCtx = null;
var audioSource = null;

//Stop the mic test
function stopAudio() {
  var audio = window.document.getElementById("audio-canvas");
  if (audio !== null && openAudionCtx !== null) {
    openAudionCtx.suspend();
    openAudionCtx = null;

    const tracks = audioSource.mediaStream.getTracks();
    tracks.forEach(track => track.stop());

    audio.remove();
  }
}

//Start the mic test
function setupAudio() {
  (function (q) {
    var b = function () { };
    b.__name__ = !0;
    b.main = function () {
        b.div = window.document.getElementById("audio-container");
        b.canvas = window.document.getElementById("audio-canvas");
        null === b.canvas && (b.canvas = window.document.createElement("canvas"), b.canvas.id = "audio-canvas"), b.div.appendChild(b.canvas);
        b.canvas.width = b.div.clientWidth;
        b.canvas.height = b.div.clientHeight;
        b.userMediaInfoDisplay = window.document.getElementById("audio-info");
        null === b.userMediaInfoDisplay &&
          (b.userMediaInfoDisplay = window.document.createElement("p"),
            b.userMediaInfoDisplay.id = "audio-info",
            b.userMediaInfoDisplay.style.display = "none",
            b.div.appendChild(b.userMediaInfoDisplay));
        b.userMediaInfoDisplay.innerHTML = "";
        b.btnStart = window.document.getElementById("audio-start");
        b.btnStart.style.position = "absolute";
        b.btnStart.style.display = "block";
        b.btnStart.addEventListener("click", function () {
          b.btnStart.style.display = "none";
          b.userMediaInfoDisplay.style.display = "block";
          b.canvas.width = b.div.clientWidth;
          b.canvas.height = b.div.clientHeight;
          navigator.mediaDevices.getUserMedia({ audio: !0 }).then(b.onGetUserMedia, b.onGetUserMediaFailed);
        });
        b.ctx = b.canvas.getContext("2d");
    };
    b.onGetUserMediaFailed = function (a) {
      window.console.log("Getting user media failed: " + n.string(a));
      b.userMediaInfoDisplay.innerHTML =
        "NotFoundError" === a.name
          ? "<strong>We can't find your microphone</strong> - that most probably means that it's either not connected, broken, or you don't have the proper webcam drivers (see below)"
          : "Microphone not authorized. Please check your media permissions settings.";
    };
    b.onGetUserMedia = function (a) {
      b.canvas.width = b.div.clientWidth;
      b.canvas.height = b.div.clientHeight;
      b.userMediaInfoDisplay.style.display = "none";
      b.actx = new AudioContext();
      b.analyser = b.actx.createAnalyser();
      b.source = b.actx.createMediaStreamSource(a);
      b.source.connect(b.analyser);
      b.visualize(a);
      this.openAudionCtx = b.actx;
      this.audioSource = b.source;
    };
    b.visualize = function (a) {
      b.ctx.clearRect(0, 0, b.canvas.width, b.canvas.height);
      var d = 0.5 * b.canvas.height,
        c = b.canvas.width / b.analyser.frequencyBinCount;
      var m = 0.5 * b.canvas.height;
      var e = new w(b.analyser.frequencyBinCount),
        f = null;
      f = function () {
        window.requestAnimationFrame(f);
        b.analyser.getFloatTimeDomainData(e);
        b.ctx.fillStyle = "#fdf1e7";
        b.ctx.fillRect(0, 0, b.canvas.width, b.canvas.height);
        b.ctx.lineWidth = 2;
        b.ctx.strokeStyle = "#e78b44";
        b.ctx.beginPath();
        for (var a = 0, h = e.length; a < h;) {
          var g = a++;
          b.ctx.lineTo(g * c, e[g] * m + d);
        }
        b.ctx.stroke();
      };
      f();
    };
    Math.__name__ = !0;
    var n = function () { };
    n.__name__ = !0;
    n.string = function (a) {
      return f.__string_rec(a, "");
    };
    var p = function () { };
    p.__name__ = !0;
    p.i32ToFloat = function (a) {
      var d = a >>> 23 & 255,
        c = a & 8388607;
      return 0 === c && 0 === d ? 0 : (1 - (a >>> 31) << 1) * 1 + Math.pow(2, -23) * c * Math.pow(2, d - 127);
    };
    p.floatToI32 = function (a) {
      if (0 === a) return 0;
      var d = 0 > a ? -a : a,
        c = Math.floor(Math.log(d) / 0.6931471805599453);
      -127 > c ? c = -127 : 128 < c && (c = 128);
      d = Math.round(8388608 * (d / Math.pow(2, c) - 1));
      8388608 === d && 128 > c && (d = 0), ++c;
      return (0 > a ? -2147483648 : 0) | c + 127 << 23 | d;
    };
    var h = function (a) {
      Error.call(this);
      this.val = a;
      this.message = String(a);
      Error.captureStackTrace && Error.captureStackTrace(this, h);
    };
    h.__name__ = !0;
    h.wrap = function (a) {
      return a instanceof Error ? a : new h(a);
    };
    h.__super__ = Error;
    h.prototype = (function (a, d) {
      function c() { }
      c.prototype = a;
      a = new c();
      for (var b in d) a[b] = d[b];
      d.toString !== Object.prototype.toString && (a.toString = d.toString);
      return a;
    })(Error.prototype, { __class__: h });
    var f = function () { };
    f.__name__ = !0;
    f.getClass = function (a) {
      if (a instanceof Array && null === a.__enum__) return Array;
      var d = a.__class__;
      if (null !== d) return d;
      a = f.__nativeClassName(a);
      return null !== a ? f.__resolveNativeClass(a) : null;
    };
    f.__string_rec = function (a, d) {
      if (null === a) return "null";
      if (5 <= d.length) return "<...>";
      var c = typeof a;
      "function" === c && (a.__name__ || a.__ename__) && (c = "object");
      switch (c) {
        case "function":
          return "<function>";
        case "object":
          if (a instanceof Array) {
            if (a.__enum__) {
              if (2 === a.length) return a[0];
              c = a[0] + "(";
              d += "\t";
              for (var b = 2, e = a.length; b < e;) {
                var g = b++;
                c = 2 !== g ? c + ("," + f.__string_rec(a[g], d)) : c + f.__string_rec(a[g], d);
              }
              return c + ")";
            }
            c = a.length;
            b = "[";
            d += "\t";
            for (e = 0; e < c;) g = e++, b += (0 < g ? "," : "") + f.__string_rec(a[g], d);
            return b + "]";
          }
          try {
            b = a.toString;
          } catch (B) {
            return "???";
          }
          if (null !== b && b !== Object.toString && "function" === typeof b && (c = a.toString(), "[object Object]" !== c)) return c;
          c = null;
          b = "{\n";
          d += "\t";
          e = null !== a.hasOwnProperty;
          for (c in a)
            e && !a.hasOwnProperty(c) ||
              "prototype" === c ||
              "__class__" === c ||
              "__super__" === c ||
              "__interfaces__" === c ||
              "__properties__" === c ||
              (2 !== b.length && (b += ", \n"), b += d + c + " : " + f.__string_rec(a[c], d));
          d = d.substring(1);
          return b + ("\n" + d + "}");
        case "string":
          return a;
        default:
          return String(a);
      }
    };
    f.__interfLoop = function (a, d) {
      if (null === a) return !1;
      if (a === d) return !0;
      var b = a.__interfaces__;
      if (null !== b)
        for (var m = 0, e = b.length; m < e;) {
          var g = m++;
          g = b[g];
          if (g === d || f.__interfLoop(g, d)) return !0;
        }
      return f.__interfLoop(a.__super__, d);
    };
    f.__instanceof = function (a, d) {
      if (null === d) return !1;
      switch (d) {
        case Array:
          return a instanceof Array ? null === a.__enum__ : !1;
        case t:
          return "boolean" === typeof a;
        case x:
          return !0;
        case u:
          return "number" === typeof a;
        case y:
          return "number" === typeof a ? (a | 0) === a : !1;
        case String:
          return "string" === typeof a;
        default:
          if (null !== a)
            if ("function" === typeof d) {
              if (a instanceof d || f.__interfLoop(f.getClass(a), d)) return !0;
            } else {
              if ("object" === typeof d && f.__isNativeObj(d) && a instanceof d) return !0;
            }
          else return !1;
          return d === z && null !== a.__name__ || d === A && null !== a.__ename__ ? !0 : a.__enum__ === d;
      }
    };
    f.__nativeClassName = function (a) {
      a = f.__toStr.call(a).slice(8, -1);
      return "Object" === a || "Function" === a || "Math" === a || "JSON" === a ? null : a;
    };
    f.__isNativeObj = function (a) {
      return null !== f.__nativeClassName(a);
    };
    f.__resolveNativeClass = function (a) {
      return q[a];
    };
    var g = function (a) {
      if (a instanceof Array && null === a.__enum__) this.a = a, this.byteLength = a.length;
      else {
        this.a = [];
        for (var d = 0; d < a;) {
          var b = d++;
          this.a[b] = 0;
        }
        this.byteLength = a;
      }
    };
    g.__name__ = !0;
    g.sliceImpl = function (a, d) {
      a = new v(this, a, null === d ? null : d - a);
      d = new r(a.byteLength);
      new v(d).set(a);
      return d;
    };
    g.prototype = {
      slice: function (a, d) {
        return new g(this.a.slice(a, d));
      },
      __class__: g
    };
    var l = function () { };
    l.__name__ = !0;
    l._new = function (a, d, b) {
      if ("number" === typeof a) {
        var c = [];
        for (d = 0; d < a;) {
          var e = d++;
          c[e] = 0;
        }
        c.byteLength = c.length << 2;
        c.byteOffset = 0;
        a = [];
        d = 0;
        for (e = c.length << 2; d < e;) d++, a.push(0);
        c.buffer = new g(a);
      } else if (f.__instanceof(a, g)) {
        null === d && (d = 0);
        null === b && (b = a.byteLength - d >> 2);
        c = [];
        for (e = 0; e < b;) {
          e++;
          var k = a.a[d++] | a.a[d++] << 8 | a.a[d++] << 16 | a.a[d++] << 24;
          c.push(p.i32ToFloat(k));
        }
        c.byteLength = c.length << 2;
        c.byteOffset = d;
        c.buffer = a;
      } else if (a instanceof Array && null === a.__enum__) {
        c = a.slice();
        a = [];
        for (d = 0; d < c.length;) e = c[d], ++d, e = p.floatToI32(e), a.push(e & 255), a.push(e >> 8) & 255, a.push(e >> 16) & 255, a.push(e >>> 24);
        c.byteLength = c.length << 2;
        c.byteOffset = 0;
        c.buffer = new g(a);
      } else throw new h("TODO " + n.string(a));
      c.subarray = l._subarray;
      c.set = l._set;
      return c;
    };
    l._set = function (a, d) {
      if (f.__instanceof(a.buffer, g)) {
        if (a.byteLength + d > this.byteLength) throw new h("set() outside of range");
        for (var b = 0, m = a.byteLength; b < m;) {
          var e = b++;
          this[e + d] = a[e];
        }
      } else if (a instanceof Array && null === a.__enum__) {
        if (a.length + d > this.byteLength) throw new h("set() outside of range");
        b = 0;
        for (m = a.length; b < m;) e = b++, this[e + d] = a[e];
      } else throw new h("TODO");
    };
    l._subarray = function (a, b) {
      b = l._new(this.slice(a, b));
      b.byteOffset = 4 * a;
      return b;
    };
    var k = function () { };
    k.__name__ = !0;
    k._new = function (a, b, c) {
      if ("number" === typeof a) {
        c = [];
        for (b = 0; b < a;) {
          var d = b++;
          c[d] = 0;
        }
        c.byteLength = c.length;
        c.byteOffset = 0;
        c.buffer = new g(c);
      } else if (f.__instanceof(a, g)) null === b && (b = 0), null === c && (c = a.byteLength - b), c = 0 === b ? a.a : a.a.slice(b, b + c), c.byteLength = c.length, c.byteOffset = b, c.buffer = a;
      else if (a instanceof Array && null === a.__enum__) c = a.slice(), c.byteLength = c.length, c.byteOffset = 0, c.buffer = new g(c);
      else throw new h("TODO " + n.string(a));
      c.subarray = k._subarray;
      c.set = k._set;
      return c;
    };
    k._set = function (a, b) {
      if (f.__instanceof(a.buffer, g)) {
        if (a.byteLength + b > this.byteLength) throw new h("set() outside of range");
        for (var c = 0, d = a.byteLength; c < d;) {
          var e = c++;
          this[e + b] = a[e];
        }
      } else if (a instanceof Array && null === a.__enum__) {
        if (a.length + b > this.byteLength) throw new h("set() outside of range");
        c = 0;
        for (d = a.length; c < d;) e = c++, this[e + b] = a[e];
      } else throw new h("TODO");
    };
    k._subarray = function (a, b) {
      b = k._new(this.slice(a, b));
      b.byteOffset = a;
      return b;
    };
    String.prototype.__class__ = String;
    String.__name__ = !0;
    Array.__name__ = !0;
    var y = { __name__: ["Int"] },
      x = { __name__: ["Dynamic"] },
      u = Number;
    u.__name__ = ["Float"];
    var t = Boolean;
    t.__ename__ = ["Bool"];
    var z = { __name__: ["Class"] },
      A = {},
      r = q.ArrayBuffer || g;
    null === r.prototype.slice && (r.prototype.slice = g.sliceImpl);
    var w = q.Float32Array || l._new,
      v = q.Uint8Array || k._new;
    f.__toStr = {}.toString;
    l.BYTES_PER_ELEMENT = 4;
    k.BYTES_PER_ELEMENT = 1;
    b.main();
  })("undefined" !== typeof window ? window : "undefined" !== typeof global ? global : "undefined" !== typeof self ? self : this);
}

//Stop the webcam test
function stopVideo() {
  var video = window.document.getElementById("webcam-video");
  if (video !== null) {
    const mediaStream = video.srcObject;
    const tracks = mediaStream.getTracks();
    tracks.forEach(track => track.stop());

    video.remove();
  }
}

//Start the webcam test
function setupVideo() {
  (function () {
    var h = function (a, d) {
      this.r = new RegExp(a, d.split("u").join(""));
    };
    h.__name__ = !0;
    h.prototype = {
      match: function (a) {
        this.r.global && (this.r.lastIndex = 0);
        this.r.m = this.r.exec(a);
        this.r.s = a;
        return null !== this.r.m;
      }
    };
    var a = function () { };
    a.__name__ = !0;
    a.main = function () {
        a.div = window.document.getElementById("webcam-video-container");
        a.div.style.background = "white";
        a.userMediaErrorDisplay = window.document.getElementById("webcam-info");
        null === a.userMediaErrorDisplay &&
          (a.userMediaErrorDisplay = window.document.createElement("p"),
            a.userMediaErrorDisplay.id = "webcam-info",
            a.userMediaErrorDisplay.style.font = '12pt "Open Sans", sans-serif',
            a.userMediaErrorDisplay.style.textAlign = "center",
            a.userMediaErrorDisplay.style.verticalAlign = "middle",
            a.userMediaErrorDisplay.style.color = "#eeeeee",
            a.div.appendChild(a.userMediaErrorDisplay));
        a.userMediaErrorDisplay.innerHTML = "";
        a.userMediaErrorDisplay.style.display = "none";
        a.fpsMeter = window.document.getElementById("fps-meter");
        null === a.fpsMeter &&
          (a.fpsMeter = window.document.createElement("p"),
            a.fpsMeter.id = "fps-meter",
            a.fpsMeter.style.position = "absolute",
            a.fpsMeter.style.font = '2em "Open Sans", sans-serif',
            a.fpsMeter.style.color = "#eeeeee",
            a.fpsMeter.style.textAlign = "right",
            a.div.appendChild(a.fpsMeter));
        a.fpsMeter.innerHTML = "";
        a.btnStart = window.document.getElementById("webcam-start");
        a.btnStart.style.width = "100%";
        a.btnStart.style.height = "100%";
        a.btnStart.style.position = "absolute";
        a.btnStart.style.display = "block";
        a.btnStart.addEventListener("click", function () {
          a.btnStart.style.display = "none";
          a.userMediaErrorDisplay.style.display = "block";
          navigator.mediaDevices
            .getUserMedia({
              audio: !1,
              video: {
                width: a.div.clientWidth,
                height: a.div.clientHeight
              }
            })
            .then(a.onGetUserMedia, a.onGetUserMediaFailed);
        });
        window.addEventListener("resize", a.updateSizes);
    };
    a.onGetUserMedia = function (b) {
      var webcamContainer = window.document.getElementById("webcam-video-container");
      a.video = window.document.getElementById("webcam-video");
      null === a.video && (a.video = window.document.createElement("video"), a.video.id = "webcam-video");
      a.div.style.height = a.div.clientHeight + "px";
      a.video.srcObject = b;
      a.video.width = a.div.clientWidth;
      a.video.height = a.div.clientHeight;
      a.video.onloadedmetadata = function (b) {
        a.video.play();
        a.frameCount = function () {
          return a.video.presentedFrames ? !0 : a.video.mozPaintedFrames;
        };
        null === a.frameCount()
          ? new h("Firefox/", "").match(window.navigator.userAgent) &&
          (b = window.document.createElement("p"),
            b.innerHTML = "FPS readings might not be accurate.<br />Please try a different browser for accurate FPS readings",
            b.style.font = 'bold 12pt "Open Sans", sans-serif',
            b.style.width = a.video.width + "px",
            b.style.textAlign = "center",
            b.style.padding = "8px",
            b.style.position = "absolute",
            b.style.top = a.video.height - 64 + "px",
            b.style.color = "#000",
            a.div.appendChild(b))
          : a.startTime = new Date().getTime();
        window.requestAnimationFrame(a.updateFPSmeter);
      };
      a.lastFrameTime = new Date().getTime();
      a.div.appendChild(a.video);
      a.fpsMeter.style.width = a.video.width - 8 + "px";
    };
    a.updateFPSmeter = function (b) {
      var d = new Date().getTime();
      null !== a.frameCount()
        ? (b = d - a.startTime, b = 1e3 * a.frameCount() / b, a.smoothFps += (b - a.smoothFps) / 20, a.fpsMeter.innerHTML = a.getFpsText(a.smoothFps))
        : a.video.currentTime !== a.lastVideoTime &&
        (a.frameTime += (d - a.lastFrameTime - a.frameTime) / 20, b = 1e3 / a.frameTime, a.fpsMeter.innerHTML = a.getFpsText(b), a.lastFrameTime = d, a.lastVideoTime = a.video.currentTime);
      a.div.clientWidth < a.video.width && a.updateSizes();
      a.div.clientHeight < a.video.height && (a.video.height = a.div.clientHeight);
      window.requestAnimationFrame(a.updateFPSmeter);
    };
    a.getFpsText = function (a) {
      return isNaN(a) ? "Waiting..." : (Math.round(10 * a) / 10).toFixed(1);
    };
    a.onGetUserMediaFailed = function (b) {
      window.console.log("Getting user media failed: " + k.string(b));
      -1 < b.name.indexOf("NotFoundError")
        ? a.userMediaErrorDisplay.innerHTML = "<strong>We couldn't find your camera</strong> that most likely means that it's either not connected, not functioning properly, or you don't have the proper webcam drivers"
        : a.userMediaErrorDisplay.innerHTML = "<strong>Your camera is not authorized</strong> Please check the media permissions settings in your web browser.";
      a.userMediaErrorDisplay.style.display = "flex";
    };
    a.updateSizes = function () {
      null !== a.video && (a.video.width = a.div.clientWidth, a.fpsMeter.style.width = a.video.width - 8 + "px");
    };
    Math.__name__ = !0;
    var k = function () { };
    k.__name__ = !0;
    k.string = function (a) {
      return e.__string_rec(a, "");
    };
    var e = function () { };
    e.__name__ = !0;
    e.__string_rec = function (a, d) {
      if (null === a) return "null";
      if (5 <= d.length) return "<...>";
      var c = typeof a;
      "function" === c && (a.__name__ || a.__ename__) && (c = "object");
      switch (c) {
        case "function":
          return "<function>";
        case "object":
          if (a instanceof Array) {
            if (a.__enum__) {
              if (2 === a.length) return a[0];
              c = a[0] + "(";
              d += "\t";
              for (var b = 2, f = a.length; b < f;) {
                var g = b++;
                c = 2 !== g ? c + ("," + e.__string_rec(a[g], d)) : c + e.__string_rec(a[g], d);
              }
              return c + ")";
            }
            c = a.length;
            b = "[";
            d += "\t";
            for (f = 0; f < c;) g = f++, b += (0 < g ? "," : "") + e.__string_rec(a[g], d);
            return b + "]";
          }
          try {
            b = a.toString;
          } catch (l) {
            return "???";
          }
          if (null !== b && b !== Object.toString && "function" === typeof b && (c = a.toString(), "[object Object]" !== c)) return c;
          c = null;
          b = "{\n";
          d += "\t";
          f = null !== a.hasOwnProperty;
          for (c in a)
            f && !a.hasOwnProperty(c) ||
              "prototype" === c ||
              "__class__" === c ||
              "__super__" === c ||
              "__interfaces__" === c ||
              "__properties__" === c ||
              (2 !== b.length && (b += ", \n"), b += d + c + " : " + e.__string_rec(a[c], d));
          d = d.substring(1);
          return b + ("\n" + d + "}");
        case "string":
          return a;
        default:
          return String(a);
      }
    };
    String.__name__ = !0;
    Array.__name__ = !0;
    Date.__name__ = ["Date"];
    a.frameTime = 0;
    a.filterStrength = 20;
    a.smoothFps = 0;
    a.main();
  })();
}

//Start the speaker test
function playSound() {
  var audio = new Audio();

  audio.src = 'audio/sound.mp3';
  audio.load();

  audio.play();
}
